import { connect } from 'react-redux';
import FilterPopover from './FilterPopover';

import { setFilters } from '../../filters/store/filtersSlice';

const mapState = state => ({
  activeSupplierAuthTab: state.loadingManagement.supplierAuthorizations.activeSupplierAuthTab,
  exchange: state.loadingManagement.filters.exchange,
  location: state.loadingManagement.filters.location,
  product: state.loadingManagement.filters.product,
  state: state.loadingManagement.filters.state,
  status: state.loadingManagement.filters.status,
  supplier: state.loadingManagement.filters.supplier,
  supplierAuthorizations: state.loadingManagement.supplierAuthorizations.supplierAuthorizations,
  type: state.loadingManagement.filters.type,
});

const mapDispatchToProps = {
  setFilters,
};

export default connect(mapState, mapDispatchToProps)(FilterPopover);
